import { Box, Skeleton, Stack } from '@mui/material'
import MapLoadingSkeleton from './MapLoadingSkeleton'

const MonitoringMapSkeleton = () => {
  return (
    <Box sx={{ display: 'flex', width: '100%', height: '100%' }}>
      <Stack sx={{ 
        width: '25%', 
        p: 2, 
        gap: 1.5,
        height: '100%',
        borderRight: '1px solid #E5E7EB',
        backgroundColor: '#FAFAFA'
      }}>
        <Box sx={{ mb: 2 }}>
          <Skeleton variant="text" width="60%" height={20} sx={{ mb: 1 }} />
          <Skeleton variant="rectangular" width="100%" height={40} sx={{ borderRadius: '4px' }} />
        </Box>
        
        {[...Array(15)].map((_, index) => (
          <Box 
            key={index} 
            sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              height: 36,
              p: 1,
              borderRadius: '4px',
              backgroundColor: '#F3F4F6',
              border: '1px solid #E5E7EB'
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
              <Skeleton variant="circular" width={20} height={20} />
              <Skeleton variant="text" sx={{ ml: 1, flex: 1, maxWidth: '70%' }} />
            </Box>
            <Skeleton variant="rectangular" width={20} height={20} sx={{ ml: 1, borderRadius: '2px' }} />
          </Box>
        ))}
      </Stack>
      <Box sx={{ width: '75%', height: '100%' }}>
        <MapLoadingSkeleton />
      </Box>
    </Box>
  )
}

export default MonitoringMapSkeleton